import Loading from './loading.vue';

export default Loading;



// WEBPACK FOOTER //
// ./src/components/_modals/loading/index.js